export default __webpack_public_path__ + "static/media/image-9.0fa1a226.png";